import React from "react"
import ActionMenu from "components/Organisms/ActionMenu"
import ActionMenuItem from "components/Organisms/ActionMenuItem"
import { useNavigate } from "react-router-dom"

const FundFlowActions = ({ className }) => {
  const navigate = useNavigate()

  function handleClick(type) {
    switch (type) {
      case "upload":
        return navigate(`/d/import/funds`)
      default:
        return
    }
  }
  return (
    <ActionMenu className={className} onClick={handleClick}>
      <ActionMenuItem id="upload" icon="upload" text="Upload Excel File" />
    </ActionMenu>
  )
}

export default FundFlowActions
